<template>
  <div v-if="queue !== null && queue.length > 0" class="queue-container">
    <div class="queue-header">
      <Clock3 :size="14" />
      <span>Очередь ({{ queue.length }})</span>
    </div>
    <ol class="queue-items">
      <li v-for="(queueItem, index) in queue" :key="queueItem.id" class="queue-item">
        <Badge variant="outline" class="queue-position">{{ index + 1 }}</Badge>
        <div class="min-w-0">
          <div class="text-sm">{{ getUserFullNameWithAccName(queueItem.user) }}</div>
          <div class="text-xs text-muted-foreground mt-1">
            {{ formatDateTime(queueItem.date_created) }}
          </div>
        </div>
      </li>
    </ol>
  </div>
</template>

<script setup lang="ts">
import { Badge } from '@/components/ui/badge';
import { Clock3 } from '@lucide/vue';

import moment from 'moment';
import { getUserFullNameWithLoginName } from '../models/saas_extension';

interface Props {
  queue: Queue[];
}

defineProps<Props>();

function getUserFullNameWithAccName(user: any): string {
  return getUserFullNameWithLoginName(user);
}

function formatDateTime(dateTime: string): string {
  return moment(dateTime).format('DD.MM.YYYY HH:mm');
}
</script>
